// @ts-nocheck

import React from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../hooks/useMergeProps';

import SearchDefaultSearchRowResult from './SearchDefaultSearchRowResult';

type SearchDefaultSearchRowResultContainerProps = {
  flagId?: string;
  isLive?: boolean;
  sportId: number;
  categoryId?: number;
  tournamentId?: number;
  subtitleNames?: Array<string>;
  secondTitle?: string;
  startDate?: number;
  title: string;
  border?: boolean;
};

const SearchDefaultSearchRowResultContainer = (ownProps: SearchDefaultSearchRowResultContainerProps) => {
  const { categoryId, tournamentId, subtitleNames: subtitleFromProps = [] } = ownProps;

  const selectedProps = useSelector((state) => {
    const categoryName = categoryId ? state?.entities?.categories?.[categoryId]?.categoryName : undefined;
    const tournamentName = tournamentId ? state?.entities?.tournaments?.[tournamentId]?.tournamentName : undefined;
    const categoryFlag = categoryId ? state?.entities?.categories?.[categoryId]?.flag : undefined;

    const subtitleNames = [];

    if (categoryName) {
      subtitleNames.push(categoryName);
    }

    if (tournamentName) {
      subtitleNames.push(tournamentName);
    }

    subtitleNames.push(...subtitleFromProps.filter((subtitle) => subtitle));

    return {
      subtitleNames,
      subtitleFlag: categoryFlag,
    };
  });

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <SearchDefaultSearchRowResult {...enhancedProps} />;
};

export default SearchDefaultSearchRowResultContainer;
